import { useEffect } from "react";

/**
 * Observes elements with class "reveal" and adds "animate-in" when scrolled into view.
 * Drop the import into any page that uses .reveal blocks and call useReveal() at the top.
 */
export function useReveal(threshold = 0.1) {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("animate-in");
        });
      },
      { threshold }
    );
    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [threshold]);
}
